import { getLocales } from '../../constants';

export const getTranslation = (prefix: string) => (id: string, params?: { [key: string]: string | number }) => {
	const locales = getLocales();
	const localeText = locales[`${prefix}.${id}`] || '';

	if (params == null) {
		return localeText;
	} else {
		return Object.keys(params)
			.reduce(
				(result: string, key: string) => result.replace(new RegExp(`\{\{${key}\}\}`, 'g'), String(params[key])),
				localeText,
			);
	}
};

export const getGlobalTranslation = getTranslation('common.utils.localization');
